module.exports = __webpack_public_path__ + "media/components/src/assets/images/before_and_after/before_after_4-fe386c8831c086a2c61f90f445871d1c.jpg";